import { produce } from 'immer';

export const captureProductsQueryKey = (productIds) => [
  'credit-card',
  'products-for-capture',
  ...productIds,
];

export const mappingProductList = (productList) => {
  return productList?.map((product) => {
    return {
      ...product,
      initFee: product.fee,
    };
  });
};

export const recalculateFee = ({
  productId,
  allRowData,
  hierarchyValue,
  isSelectHierarchy,
}) => {
  return produce(allRowData, (draftState) => {
    const foundIndex = allRowData?.findIndex(
      (row) => row.productId === productId
    );
    if (isSelectHierarchy) {
      draftState[foundIndex].fee = hierarchyValue.fee;
      draftState[foundIndex]['hierarchyId'] = hierarchyValue.productHierarchyId;
      draftState[foundIndex]['packDescription'] =
        hierarchyValue.packDescription;
    } else {
      draftState[foundIndex].fee = draftState[foundIndex].initFee;
      draftState[foundIndex]['hierarchyId'] = null;
      draftState[foundIndex]['packDescription'] = null;
    }
  });
};

export const getNewRowData = ({ productId, allRowData, newHierarchies }) => {
  return produce(allRowData, (draftState) => {
    const foundIndex = allRowData?.findIndex(
      (row) => row.productId === productId
    );

    draftState[foundIndex].hierarchies = newHierarchies;
  });
};

export const mappingHierarchies = (hierarchies) => {
  return hierarchies.map((hierarchy) => {
    return {
      ...hierarchy,
      ...hierarchy.metadata,
      productItemLinks: hierarchy.products,
    };
  });
};

export const getAllIXOneRows = (gridInst) => {
  let rowData = [];

  if (gridInst?.api) {
    gridInst.api.forEachNode((node) => rowData.push(node.data));
  }

  return rowData;
};
